import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { format } from 'date-fns';

export const ErrorLogsTable = () => {
  const { data: logs } = useQuery({
    queryKey: ['error-logs'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('monitoring_logs')
        .select('*')
        .eq('type', 'error')
        .order('created_at', { ascending: false })
        .limit(10);

      if (error) {
        console.error("Error fetching error logs:", error);
        throw error;
      }
      
      return data;
    },
    refetchInterval: 5000 // Atualiza a cada 5 segundos
  });

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Tipo</TableHead>
          <TableHead>Descrição</TableHead>
          <TableHead>Data/Hora</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {logs?.map((log) => (
          <TableRow key={log.id} className="bg-red-50">
            <TableCell className="text-red-600 font-medium">
              {log.type.toUpperCase()}
            </TableCell>
            <TableCell>{log.description}</TableCell>
            <TableCell>
              {format(new Date(log.created_at), 'dd/MM/yyyy HH:mm:ss')}
            </TableCell>
          </TableRow>
        ))}
        {(!logs || logs.length === 0) && (
          <TableRow>
            <TableCell colSpan={3} className="text-center py-4 text-gray-500">
              Nenhum erro encontrado
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};